import { keepPreviousData, useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { ApiConfig } from '@/config/api.config';
import { useAxiosAuth } from '@/hooks/useAxiosAuth';
import { AppReleaseLatestListResponseDto, ReadLatestNewsRequestDto } from '@/features/releases/types/releases-dto';

export const useReleaseLatestListApi = () => {
    const axiosInstance = useAxiosAuth();
    const queryClient = useQueryClient();

    const {
        data: releaseLatestListData,
        isLoading: isLoadingReleaseLatestListData,
        isError: isErrorReleaseLatestListData,
    } = useQuery({
        queryKey: [ApiConfig.queries.features.releases.queryKeys.latest],
        queryFn: async (): Promise<AppReleaseLatestListResponseDto> => {
            const url = ApiConfig.queries.features.releases.endpoints.latest;
            const response = await axiosInstance.get<AppReleaseLatestListResponseDto>(url);
            return response.data;
        },
        placeholderData: keepPreviousData,
    });

    const {
        mutateAsync: markReadReleaseLatestList,
        isPending: isMarkingReadReleaseLatestList,
        isError: isErrorMarkingReadReleaseLatestList,
    } = useMutation({
        mutationFn: async (ids: ReadLatestNewsRequestDto) => {
            const url = ApiConfig.queries.features.releases.endpoints.markRead;
            const response = await axiosInstance.patch(url, ids);
            return response.data;
        },
        onSuccess: async () => {
            await queryClient.invalidateQueries({
                queryKey: [ApiConfig.queries.features.releases.queryKeys.latest],
            });
        },
        onError: (error) => {
            console.error(error);
        },
    });

    return {
        releaseLatestListData,
        isLoadingReleaseLatestListData,
        isErrorReleaseLatestListData,
        markReadReleaseLatestList,
        isMarkingReadReleaseLatestList,
        isErrorMarkingReadReleaseLatestList,
    };
};
